import React from 'react';
import { Container, CssBaseline, Grid, withStyles } from '@material-ui/core';
import Topbar from '../components/Topbar';
import ChannelItem from './ChannelItem';
import './ChannelItem.css';
import { EVENT_NAME } from '../constants';
import MainContext from '../MainContext';
import MainProvider from '../MainProvider';

const moment = require('moment');

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  // topbar 제외한 페이지 영역
  pageDiv: {
    backgroundColor: '#eee',
    overflowY: 'auto',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 89px)',
    },
  },
  //날짜 영역 표시 container 인지 grid 일지 아직 모름
  dateContainer: {
    backgroundColor: '#21222b',
  },
  // 채널카드용 상단 공백
  upperSpacing: {
    paddingTop: '30px', //임의값
  },
  cardGrid: {
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px !important',
    },
  },
  // 전체 채널카드 담는 container
  channelItemContainer: {
    paddingTop: '40px',
    paddingBottom: '40px',
    marginBottom: '70px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
      paddingBottom: 150,
    },
  },
  enterMsgGrid: {
    padding: '0px',
    [theme.breakpoints.up('sm')]: {
      padding: '20px',
    },
  },
  enterText: {
    fontSize: '23px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    /* lineHeight: '1.76', */
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#f7f79f',
    [theme.breakpoints.down('sm')]: {
      fontSize: '19px',
    },
  },
});

class Room extends React.Component {
  //static contextType = MainContext;

  constructor(props) {
    super(props);
    this.goToLive = this.goToLive.bind(this);
    this.state = {
      opened: false,
      detail: [],
      dayTitle: '',
      dayIndex: 0,
    };
  }

  componentDidMount() {
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('signin');
      return;
    }

    this.setState({ height: document.body.scrollHeight + 'px' });
    const eventItem = sessionStorage.getItem('Item');

    if (!eventItem) this.props.history.push('/main');
    else {
      const jsonItem = JSON.parse(eventItem);
      this.setState({ channel: jsonItem.channel });
    }
  }

  goToLive(ch) {
    this.setState({ opened: true });
    if (this.state.win) {
      this.state.win.close();
    }

    let win = window.open(`/#/live?ch=${ch}`, 'liveWin');
    win.document.title = EVENT_NAME + '- Live';
    this.setState({ win: win });
  }

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location.pathname;

    return (
      <MainProvider>
        <React.Fragment>
          <CssBaseline />
          <Topbar currentPath={currentPath} />
          <MainContext.Consumer>
            {(value) => (
              <div className={classes.pageDiv}>
                {/* //상단 공백용 div */}
                <div className={classes.upperSpacing} />
                <Container maxWidth="xs">
                  <Grid
                    container
                    justifyContent="center"
                    style={{ borderRadius: '20.4px', backgroundColor: this.props.theme.palette.primary.main, padding: '8px' }}
                  >
                    <div className="dateText">
                      {value.arrDate && value.arrDate.length > 0 ? moment(value.arrDate[value.dayIndex]).format('MMMM DD (ddd.)') : ''}
                    </div>
                  </Grid>
                </Container>

                <Container className={classes.channelItemContainer}>
                  <div>
                    {value.arrCurrentSesseion && value.arrCurrentSesseion.length > 0 ? (
                      <Grid container spacing={3} justifyContent="center">
                        {value.arrCurrentSesseion.map((channel, idx) => {
                          return (
                            <ChannelItem
                              data={channel}
                              key={idx}
                              channelIdx={idx}
                              customColor={idx}
                              onEnterHandler={(ch) => this.goToLive(ch.channel)}
                            />
                          );
                        })}
                      </Grid>
                    ) : (
                      ''
                    )}
                  </div>
                </Container>
              </div>
            )}
          </MainContext.Consumer>
        </React.Fragment>
      </MainProvider>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Room);
